import { useRef, useState } from "react";
import { C } from "../../styles/theme";

function resizeImage(file, maxDim = 900, quality = 0.82) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(reader.error);
    reader.onload = () => {
      const img = new Image();
      img.onerror = () => reject(new Error("Invalid image"));
      img.onload = () => {
        let { width, height } = img;
        if (width > maxDim || height > maxDim) {
          const scale = maxDim / Math.max(width, height);
          width = Math.round(width * scale);
          height = Math.round(height * scale);
        }
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        canvas.getContext("2d").drawImage(img, 0, 0, width, height);
        resolve(canvas.toDataURL("image/jpeg", quality));
      };
      img.src = reader.result;
    };
    reader.readAsDataURL(file);
  });
}

export default function ImgUploadFld({ label, value, onChange, w = 64, h = 64, round = false, maxDim = 900, showPreview = true, buttonLabel }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const pick = async e => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (!file.type.startsWith("image/")) { setError("Please choose an image file"); return; }
    setError("");
    setBusy(true);
    try {
      const dataUrl = await resizeImage(file, maxDim);
      onChange(dataUrl);
    } catch {
      setError("Could not read that image");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ marginBottom: 11 }}>
      {label && <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: C.blue, marginBottom: 4 }}>{label}</label>}
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        {showPreview && value && (
          <div style={{ position: "relative", flexShrink: 0 }}>
            <img src={value} alt="" style={{ width: w, height: h, borderRadius: round ? "50%" : 8, objectFit: "cover", border: "1.5px solid " + C.border, display: "block" }} />
            <button type="button" onClick={() => onChange("")} title="Remove" style={{ position: "absolute", top: -6, right: -6, width: 18, height: 18, borderRadius: "50%", background: "#ef4444", color: "#fff", border: "2px solid #fff", fontSize: 10, lineHeight: "14px", cursor: "pointer", padding: 0 }}>✕</button>
          </div>
        )}
        <div>
          <button type="button" onClick={() => inputRef.current?.click()} disabled={busy} style={{ padding: "8px 14px", borderRadius: 8, border: "1.5px solid " + C.border, background: "#fff", fontSize: 13, fontWeight: 600, color: C.blue, cursor: busy ? "wait" : "pointer" }}>
            {busy ? "Uploading..." : buttonLabel || (value ? "Change Image" : "Upload Image")}
          </button>
          <input ref={inputRef} type="file" accept="image/*" onChange={pick} style={{ display: "none" }} />
          {error && <div style={{ fontSize: 11, color: "#ef4444", marginTop: 4 }}>{error}</div>}
        </div>
      </div>
    </div>
  );
}
